import { render, staticRenderFns } from "./AiStats.vue?vue&type=template&id=c868bdea&scoped=true"
import script from "./AiStats.vue?vue&type=script&lang=js"
export * from "./AiStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c868bdea",
  null
  
)

export default component.exports